import { Box } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import consts from "../../main/consts";
import nav from "../../main/navigationConfig";
import { getLabelOrigem, getListOrigens } from "../../main/origem";
import { getRowsAndTotal } from "../../state/order/actions";
import { salesChannelIsAmericanas } from "../../utils/check-sales-channel";
import ContentTable from "./ContentTable";
import {
	getCostString,
	getTimeDiff,
	getTimeStr,
	getTimeWithHourStr,
} from "./helpers";
import TipoEntrega from "./helpers/TipoEntrega";
import PreSaleIcon from "./icons/PreSaleIcon";

const styles = (theme) => ({
	totalCost: {
		fontWeight: "bold",
	},
	warning: {
		width: 10,
	},
	circle: {
		display: "inline-block",
		width: 26,
		height: 26,
		padding: 3,
		backgroundColor: (props) => theme.palette.pages.picking,
		borderRadius: 20,
		"& .icon": {
			color: "white",
		},
	},
	maxWidthCol: {
		maxWidth: 170,
		[theme.breakpoints.down("sm")]: {
			maxWidth: "inherit",
		},
	},
	duracao: {
		textTransform: "lowercase",
	},
	capitalize: {
		textTransform: "capitalize",
	},
});

const getHeaders = (classes, pedidosRow) => [
	{
		title: "Nº Pedido",
		align: "left",
		dataField: "codigoExterno",
		class: classes.maxWidthCol,
	},
	{
		title: "Pré-venda",
		align: "left",
		dataField: "preVenda",
		class: classes.maxWidthCol,
		render: (preVenda) => {
			if (preVenda) {
				return <PreSaleIcon />;
			}
			return null;
		},
	},
	{
		title: "Origem",
		align: "left",
		dataField: "origem",
		filter: "origem",
		filterOptions: getListOrigens(),
		render: (data) => getLabelOrigem(data),
	},
	{
		title: "Data",
		align: "left",
		dataField: "dataInclusao",
		render: (data) => new Date(data).toLocaleDateString(),
	},
	{
		title: "Entrega estimada",
		align: "left",
		dataField: "dhEntregaEstimada",
		render: (data, row) =>
			salesChannelIsAmericanas(row.canalDeVendas)
				? getTimeStr(data)
				: getTimeWithHourStr(data),
	},
	{
		title: "Tempo para Confirmação",
		align: "left",
		dataField: "tempoParaConfirmacao",
	},
	{
		title: "Cliente",
		align: "left",
		dataField: "cliente",
		class: classes.capitalize,
		render: (data) => data && data.nome.toLowerCase(),
	},
	{
		title: "Canal de venda",
		align: "left",
		dataField: "canalDeVendas",
		render: (data) => data,
	},
	{
		title: "Tipo de Entrega",
		align: "left",
		dataField: "tipoEntrega",
		render: (data) => <TipoEntrega tipoEntrega={data} />,
	},
	{
		title: "Total",
		align: "right",
		dataField: "valorTotal",
		class: classes.totalCost,
		render: getCostString,
	},
];

const PAGE_NAME = "picking";
const ROWS_PER_PAGE = consts.ROWS_PER_PAGE;
class EmSeparacao extends React.Component {
	componentDidMount() {
		this.loadGridData(0, ROWS_PER_PAGE);
	}

	componentDidUpdate(prevProps) {
		const {
			loja,
			orders: { filters },
			limit,
		} = this.props;

		if (
			loja !== prevProps.loja ||
			filters !== prevProps.orders.filters ||
			prevProps.limit !== limit
		) {
			this.loadGridData(0, ROWS_PER_PAGE, true);
		}
	}

	loadGridData = (page, limits, avoidSpinner = false) => {
		const {
			getRowsAndTotal,
			orders: { filters },
			limit,
		} = this.props;
		limits = limits || ROWS_PER_PAGE;

		const navigationIndexByPageId = nav.findIndex(
			(item) => item.id === PAGE_NAME,
		);

		getRowsAndTotal({
			page,
			limit: limit,
			filters: {
				...filters,
				status: nav[navigationIndexByPageId].status.join(),
				ordemDataInclusao: "asc",
			},
			avoidSpinner,
			pageId: PAGE_NAME,
		});
	};

	clickRow = (row) => {
		this.props.history.push(`${consts.CONTEXT}/picking/${row.numero}`, {
			data: { page: PAGE_NAME },
		});
	};

	render() {
		return (
			<ContentTable
				loaded={this.props.orders.loaded}
				limit={this.props.limit}
				title="Em Separação"
				subtitle="Sempre confira os itens antes de confirmar o pedido."
				page={PAGE_NAME}
				headers={getHeaders(
					this.props.classes,
					this.props.orders.grids[PAGE_NAME].rows,
				)}
				onClickRow={this.clickRow}
				rows={this.props.orders.grids[PAGE_NAME].rows}
				total={this.props.orders.grids[PAGE_NAME].total}
				store={this.props.orders.grids[PAGE_NAME].store}
				selectedPage={this.props.orders.page}
				rowsPerPage={ROWS_PER_PAGE}
				showPaginator={false}
				onHandlePageChange={this.loadGridData}
				selectedOrigemFilter={getLabelOrigem(
					this.props.orders.grids[PAGE_NAME].selectedFilter,
				)}
			/>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		orders: state.orders,
		loja: state.auth.loja,
		limit: state.orders.limit,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators({ getRowsAndTotal }, dispatch);
export default compose(
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps),
)(EmSeparacao);
